import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Logo from './Logo';

const propTypes = {
  addContentWrap: PropTypes.bool,
};

const HeaderDefault = ({ addContentWrap }) => (
  <Header addContentWrap={addContentWrap}>
    <div className="site-brand">
      <Logo linksTo="/" externalLink />
    </div>
  </Header>
);

HeaderDefault.propTypes = propTypes;

export default HeaderDefault;
